import './App.css';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, HashRouter, Route, Routes, useLocation } from 'react-router-dom';
import theme from './theme';
import { RouteWrapper } from './pages/ConsolePages/RouteWrapper';

const BuildTarget = process.env.REACT_APP_TARGET;
const ApiPath = process.env.REACT_APP_API_PATH;
const Origin = window.location.origin; 

function App() {
  return (
    <>
    {(() => {
      console.log(BuildTarget);
      console.log(ApiPath);
      console.log(Origin);

      if (BuildTarget === "WEB") {
        return (
          <BrowserRouter basename="/">
            <PageRoute />
          </BrowserRouter>
        );
      }

      // アプリ用にHashRouterを使う
      // ！注意！
      // HashRouterを使っているためリンクの形は`http://{domain}/#/console/`のようになる。
      if (BuildTarget === "APP") {
        return (
          <HashRouter basename="/">
            <PageRoute />
          </HashRouter>
        );
      }

      return <>未作成</>;
    })()}
    </>
  );
}

function PageRoute() {
  // オリジナルのパスを記憶する
  const location = useLocation();
  // ルーターの state は型情報を持たないため、実行時に形を確認して取り出す。
  const routerState: unknown = location.state;
  const fromValue = typeof routerState === "object" && routerState !== null && "from" in routerState ? routerState.from : undefined;
  const originalPath = typeof fromValue === "object" && fromValue !== null && "pathname" in fromValue && typeof fromValue.pathname === "string" ? fromValue.pathname : undefined;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route key="console" path={"/console/*"} element={<RouteWrapper originalPath={originalPath} />} />
        <Route key="systemAdmin" path={"/system-admin/*"} element={<>ﾏﾀﾞﾂｸｯﾃﾅｲﾖ</>} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
